import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DOC_ARTICLES, isDocSlug, type DocSlug } from "@/content/docsArticles";
import { PublicPageShell } from "@/features/public/layout/PublicPageShell";

function GettingStartedBody() {
  return (
    <>
      <div className="pub-step-cards">
        <div className="pub-step-card">
          <strong>1 · Install</strong>
          <span>Stripe Marketplace</span>
        </div>
        <div className="pub-step-card">
          <strong>2 · Open</strong>
          <span>Dashboard apps drawer</span>
        </div>
        <div className="pub-step-card">
          <strong>3 · Export</strong>
          <span>PDFs &amp; ZIP</span>
        </div>
      </div>
      <p className="pub-doc-article-lead mt-4">
        Sign in through your Stripe Dashboard — open a link from the drawer and you&apos;re
        redirected to the web app, authenticated automatically. No separate password.
      </p>
    </>
  );
}

function resolveActiveSlug(hash: string): DocSlug {
  if (hash && isDocSlug(hash)) {
    return hash;
  }
  return "getting-started";
}

export function DocsPage() {
  const location = useLocation();
  const activeSlug = resolveActiveSlug(location.hash.slice(1));
  const article = DOC_ARTICLES.find((item) => item.slug === activeSlug) ?? DOC_ARTICLES[0];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeSlug]);

  return (
    <PublicPageShell
      eyebrow="Documentation"
      title="Guides"
      lead="Install, export, billing, and security — short guides for each topic."
    >
      <div className="pub-docs-layout">
        <aside className="pub-docs-sidebar">
          <h2>Guides</h2>
          {DOC_ARTICLES.map((item) => (
            <a
              key={item.slug}
              href={`#${item.slug}`}
              className={item.slug === activeSlug ? "active" : undefined}
            >
              {item.title}
            </a>
          ))}
        </aside>
        <article className="pub-doc-article">
          <h1>{article.title}</h1>
          {article.lead ? <p className="pub-doc-article-lead">{article.lead}</p> : null}
          {article.slug === "getting-started" ? <GettingStartedBody /> : null}
        </article>
      </div>
    </PublicPageShell>
  );
}
